module.exports = __webpack_public_path__ + "static/media/Clip Store title.80a5424a.png";